import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "edge-extensions"
    }}>{`Edge extensions`}</h1>
    <p>{`Edge extensions are extensions that you can use with the Mobile SDKs that are built on the Edge.`}</p>
    <h2 {...{
      "id": "extensions"
    }}>{`Extensions`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./edge-network/index.md"
        }}>{`Adobe Experience Platform Edge Network`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./adobe-journey-optimizer/index.md"
        }}>{`Adobe Journey Optimizer`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./adobe-journey-optimizer-decisioning/index.md"
        }}>{`Adobe Journey Optimizer - Decisioning`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./media-for-edge-network/index.md"
        }}>{`Adobe Streaming Media for Edge Network`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./consent-for-edge-network/index.md"
        }}>{`Consent for Edge Network`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./identity-for-edge-network/index.md"
        }}>{`Identity for Edge Network`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./lifecycle-for-edge-network/index.md"
        }}>{`Lifecycle for Edge Network`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      